import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { filter, take } from "rxjs";
import { AccordionComponent } from "../../../../components/common/accordion/accordion.component";
import { NoDataComponent } from "../../../../components/common/no-data/no-data.component";
import { GenericModalComponent } from "../../../../components/modal-templates/user-story-basic-view/generic-modal.component";
import { SharedComponents } from "../../../../components/shared.module";
import {
  impactedTestCasesData,
  mostImpactedExpandField
} from "../../../../core/dummy/dummy-data";
import { INZorroOutput } from "../../../../core/models/common";
import { selectMappingResponse } from "../../../../core/ngrx/selectors/test-prioritization.selectors";
import { RestService } from "../../../../core/services/rest.service";
import { ToasterService } from "../../../../core/services/toaster-service";
import { impactedTestCasesColumns } from "../../../../core/table-templates/impacted-test-cases-table";
import { MostImpactedTestCasesTable } from "../../../../core/table-templates/most-impacted-test-cases-table";
import { MessageEnum } from "../../../../core/utils/message.enum";
import { ImpactedAnalysisItemComponent } from "./impacted-analysis-item/impacted-analysis-item.component";

@Component({
  selector: "app-impacted-test-case-analysis",
  standalone: true,
  imports: [
    CommonModule,
    AccordionComponent,
    NoDataComponent,
    ...SharedComponents,
  ],
  templateUrl: "./impacted-test-case-analysis.component.html",
  styleUrl: "./impacted-test-case-analysis.component.scss",
})
export class ImpactedTestCaseAnlysisComponent {
  @Input()
  testcase: any = {};

  @Input()
  fileName: any = "";

  @Input()
  view: any = "";

  private modalService = inject(NgbModal);

  data: any = {
    impactedCount: 9,
    table: {},
    detailed: {},
  };

  accordionItems: any = [];
  selectedFileNode: any;
  isDetailViewEnabled = false;
  mappingResponse$ = this.store.select(selectMappingResponse);
  mappingId: any = "";
  impactedFileCount = 0;
  loading = false;
  modifiedFileCount: number = 0;
  tableData: any;

  constructor(private store: Store, private restService: RestService, private readonly toaster: ToasterService) {
    this.mappingResponse$
      .pipe(
        filter((response) => !!response),
        take(1)
      )
      .subscribe((response) => {
        this.mappingId = response.id;
      });
  }

  ngOnInit() {
    console.log("CALL IMPACTED TESTCASES");
    if (this.view === "most-impacted-testcase-analysis") {
      this.getGeneratedMostImpactedTestcases();
    } else {
      this.getGeneratedImpactedTestcases();
    }
    this.data.table.columns = impactedTestCasesColumns;
    this.data.table.rows = impactedTestCasesData;
  }

  groupBySourceCodePath = (data: any) => {
    return data.reduce((result: any, item: any) => {
      const path = item.sourcecodepath;
      const fileName = path.substring(path.lastIndexOf("/") + 1);
      if (!result[fileName]) {
        result[fileName] = [];
      }
      result[fileName].push(item);
      return result;
    }, {});
  };

  loadAccordionItems(item: any) {
    this.impactedFileCount = item?.length;
    const codeDetails = this.groupBySourceCodePath(item);
    if (codeDetails) {
      this.accordionItems = [];
      this.modifiedFileCount = Object.entries(codeDetails)?.length;
      Object.entries(codeDetails).forEach(([key, value]) => {
        const data: any = {};
        data.title = key;
        data.component = ImpactedAnalysisItemComponent;
        data.codeBlocks = [
          {
            title: `${key} Patch Details`,
            code: codeDetails[key]?.[0]?.patch,
          },
        ];
        data.mappings = value;
        this.accordionItems.push(data);
      });
    }

    this.loading = false;
  }

  getGeneratedMostImpactedTestcases() {
    this.loading = true;
    this.restService
      .getMostImpactedTestcases(this.mappingId, this.fileName)
      // .getMostImpactedTestcases(this.mappingId, "Defect_Report_V1_22.csv")
      .subscribe({
        next: (item: any) => {
          this.loading = false;
          console.log("Most Impacted Testcases", item);
          this.loadTable(item?.data);
        },
        error: (err) => {
          this.toaster.pop({ type: 'error', text: MessageEnum.MOST_IMPACTED_TESTCASES_LOAD_FAILURE });
          console.error("Error get impacted test cases:", err);
          this.loading = false;
        },
      });
  }

  getGeneratedImpactedTestcases() {
    this.loading = true;
    this.restService.getGeneratedImpactedTestcases(this.mappingId).subscribe({
      next: (item: any) => {
        console.log("Impacted Testcases", item);
        this.loadAccordionItems(item?.data);
      },
      error: (err) => {
        this.toaster.pop({ type: 'error', text: MessageEnum.IMPACTED_TESTCASES_LOAD_FAILURE });
        console.error("Error get impacted test cases:", err);
        this.loading = false;
      },
    });
  }

  loadTable(data: any) {
    this.accordionItems = [];
    this.tableData = {
      data: data,
      columns: MostImpactedTestCasesTable,
    };
  }

  selectFileNode(item: any) {
    this.data.detailed.files.forEach((file: any) => {
      file.selected = false;
    });
    item.selected = true;
    this.selectedFileNode = item;
  }

  handleReportDownload(event: any) {
    console.log(event);
  }

  handleTableActions(event: INZorroOutput) {
    if (event.data?.column?.key === "open_modal") {
      this.openModal(event.data.row);
    }
  }

  openModal(data: any) {
    const modalRef = this.modalService.open(GenericModalComponent, {
      centered: true,
      windowClass: "user-story-modal",
      size: "xl",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.contentList = mostImpactedExpandField;
    modalRef.componentInstance.title = "Most Impacted Test Case - Details";
  }
}
